import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';

import ZignalWidgets from 'zignal-widgets/lib/reducer';

import { reducer as form } from 'redux-form';

import { reducer as AdminSettings } from 'containers/AdminSettings';
import { reducer as DataSources } from 'containers/DataSources';
import { reducer as AppUser } from 'containers/AppUser';
import { reducer as BotIntelligence } from 'containers/BotIntelligence';
import { reducer as CreateDashboardLink } from 'containers/CreateDashboardLink';
import { reducer as DashboardLinkAccess } from 'containers/DashboardLinkAccess';
import { reducer as DetectSettings } from 'containers/DetectSettings';
import { reducer as DiscoverHistorics } from 'containers/DiscoverHistorics';
import { reducer as NarrativeFeeds } from 'containers/NarrativeFeeds';
import { reducer as ForgotCredentialsModal } from 'containers/ForgotCredentialsModal';
import { reducer as TwitterImports } from 'containers/TwitterImports';
import { reducer as HistoricalImport } from 'containers/HistoricalImport';
import { reducer as Login } from 'containers/Login';
import { reducer as Notification } from 'containers/Notification';
import { reducer as StoryAndSourceChecker } from 'containers/StoryAndSourceChecker';
import { reducer as SyndicatedStoryModal } from 'containers/SyndicatedStoryModal';
import { reducer as WidgetEmbedModal } from 'containers/WidgetEmbedModal';
import { reducer as Zccs } from 'containers/Zccs';
import { reducer as TierOverride } from 'containers/TierOverride';
import { reducer as ZccInstallations } from 'containers/ZccInstallations';
import { reducer as AdminManagement } from 'containers/AdminManagement';
import { reducer as InternalAdminsTab } from 'containers/InternalAdminsTab';
import { reducer as DefaultLocations } from 'containers/DefaultLocations';
import { reducer as UserForm } from 'containers/UserForm';
import { reducer as DashboardSettingsModal } from 'containers/DashboardSettingsModal';
import { reducer as BulkEdition } from 'containers/BulkEdition';
import { reducer as BaseWizard } from 'containers/BaseWizard';
import { reducer as SimpleWizard } from 'containers/ExampleWizards/SimpleWizard';
import { reducer as ComplexWizard } from 'containers/ExampleWizards/ComplexWizard';
import { reducer as TrendingStoriesOverview } from 'containers/TrendingStoriesOverview';
import { reducer as DashboardSummary } from 'containers/DashboardSummary';

export default combineReducers({
  routing: routerReducer,
  form,
  AdminSettings,
  DataSources,
  AppUser,
  BotIntelligence,
  CreateDashboardLink,
  DashboardLinkAccess,
  DetectSettings,
  NarrativeFeeds,
  ForgotCredentialsModal,
  TwitterImports,
  HistoricalImport,
  Login,
  Notification,
  StoryAndSourceChecker,
  SyndicatedStoryModal,
  WidgetEmbedModal,
  Zccs,
  TierOverride,
  ZignalWidgets,
  ZccInstallations,
  AdminManagement,
  InternalAdminsTab,
  DefaultLocations,
  UserForm,
  DashboardSettingsModal,
  BulkEdition,
  BaseWizard,
  SimpleWizard,
  ComplexWizard,
  TrendingStoriesOverview,
  DiscoverHistorics,
  DashboardSummary,
});
